import React from "react";
import {
  Breadcrumbs,
  Typography,
  Button,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  Grid
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actionCreators from "../actions/valueActions";
import { fetchPlot } from "../actions/variableActions";
import Plot from "../components/VariableValuesPlot";
import TriangularNumberForm from "../components/TriangularNumberForm";
import CreateObjectDialog from "../components/CreateObjectDialog";

const styles = theme => ({
  root: {
    // padding: 10
  },
  link: {
    textDecoration: "none",
    color: theme.palette.text.primary
  },
  fab: {
    position: "absolute",
    bottom: theme.spacing(2),
    right: theme.spacing(3)
  },
  button: {
    margin: theme.spacing(1)
  },
  list: {
    width: "100%",
    padding: "5px"
  },
  listItem: {
    border: "2px solid " + theme.palette.primary.light,
    borderRadius: "5px",
    marginBottom: "5px"
  },
  text: {
    color: theme.palette.text.primary
  }
});

class ValueDetailsContainer extends React.Component {
  constructor() {
    super();
    this.refresh = this.refresh.bind(this);
    this.handleApply = this.handleApply.bind(this);
  }

  refresh() {
    this.props.fetchValueDetails(this.props.match.params.valueId);
  }

  componentDidMount() {
    this.refresh();
  }

  handleApply() {
    const { newValue, UpdateNumber, fetchPlot, variable } = this.props;

    const { type, ...parameters } = newValue.number;
    const parametersArray = Object.values(parameters);
    UpdateNumber(newValue.id, type, parametersArray).then(() =>
      fetchPlot(variable.id)
    );
  }
  validateParameters(number) {
    let parameters;
    switch (number.type) {
      case "triangular":
        parameters = ["a", "b", "c"];
        break;
      case "trapezoidal":
        parameters = ["a", "b", "c", "d"];
        break;
      case "gaussian":
        parameters = ["mean", "standard deviation"];
        break;
      case "bell":
        parameters = ["center", "width", "slope"];
        break;
      case "pi":
        parameters = ["bottom left", "top left", "top right", "bottom right"];
        break;
      case "spike":
        parameters = ["center", "width"];
        break;
      default:
        parameters = [];
    }
    for (let key in number) {
      if (!parameters.includes(key) && key !== "type") {
        delete number[key];
      }
    }
    for (let param of parameters) {
      if (!Object.keys(number).includes(param)) {
        number[param] = 0;
      }
    }
  }

  async handleEditVariable(name) {
    const {
      value,
      setDisplayEditValueDialog,
      updateValue,
      fetchPlot,
      variable
    } = this.props;
    await updateValue(value.id, name);
    await fetchPlot(variable.id);
    setDisplayEditValueDialog(false);
    this.refresh();
  }

  render() {
    const {
      classes,
      variable,
      value,
      plot,
      newValue,
      setType,
      setParams,
      setDisplayEditValueDialog,
      displayEditValueDialog
    } = this.props;
    if (!value.id) {
      return null;
    }

    if (!newValue.number) {
      setType("none");
      return null;
    }

    let number = newValue.number;
    this.validateParameters(number);

    return (
      <div className={classes.root}>
        <Breadcrumbs>
          <Link className={classes.link} to="/variables/">
            Variables
          </Link>
          <Link className={classes.link} to={`/variables/${variable.id}/`}>
            {variable.name}
          </Link>
          <Typography color="textPrimary">{value.name}</Typography>
        </Breadcrumbs>

        <Plot name={variable.name} values={plot} />

        <Grid container alignItems="center" justify="center">
          <Grid item xs={12}>
            <Button
              className={classes.button}
              variant="contained"
              onClick={() => setDisplayEditValueDialog(true)}
            >
              Edit value name
            </Button>
          </Grid>
          <Grid item>
            <FormControl>
              <InputLabel>type</InputLabel>
              <Select
                value={newValue.number.type}
                onChange={event => setType(event.target.value)}
              >
                {/* <MenuItem value="none">none</MenuItem> */}
                <MenuItem value="triangular">triangular</MenuItem>
                <MenuItem value="trapezoidal">trapezoidal</MenuItem>
                <MenuItem value="gaussian">gaussian</MenuItem>
                <MenuItem value="bell">bell</MenuItem>
                <MenuItem value="pi">pi shape</MenuItem>
                <MenuItem value="spike">spike</MenuItem>
              </Select>
              <TriangularNumberForm number={number} onChange={setParams} />
              <Button
                className={classes.button}
                variant="contained"
                color="primary"
                onClick={this.handleApply}
                disabled={newValue === value || newValue.number.type === "none"}
              >
                Apply
              </Button>
              {/* <Button variant="contained" color="secondary">
            Cancel
          </Button> */}
            </FormControl>
          </Grid>
        </Grid>
        <CreateObjectDialog
          open={displayEditValueDialog}
          onClose={() => setDisplayEditValueDialog(false)}
          onSubmit={name => this.handleEditVariable(name)}
          title="Edit linguistic value"
          text="New value name"
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    variable: state.variable.data,
    value: state.value.data,
    newValue: state.value.newValue,
    plot: state.variable.plot,
    displayEditValueDialog: state.value.displayEditValueDialog
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators({ ...actionCreators, fetchPlot }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(ValueDetailsContainer));
